import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import { TextBase } from '../../Typography';

export interface RadioGroupItem {
  label: string | ReactNode;
  value: string;
  id: string | number;
  component?: string | ReactNode;
  disabled?: boolean;
}

export interface RadioGroupProps {
  radios: RadioGroupItem[];
  onChange: (value: RadioGroupItem['value']) => void;
  value: string;
  defaultValue?: string;
  horizontal?: boolean;
}

export const RadioGroup = ({
  radios,
  onChange,
  value,
  defaultValue,
  horizontal = false,
}: RadioGroupProps) => {
  return (
    <RadioGroupPrimitive.Root
      onValueChange={onChange}
      defaultValue={defaultValue}
      className={classNames([
        'flex',
        horizontal ? 'flex-row gap-4 flex-wrap' : 'flex-col',
      ])}
    >
      {radios.map((radio: RadioGroupItem) => (
        <div
          className="flex items-start mt-1"
          key={radio.id}
        >
          <RadioGroupPrimitive.Item
            className={classNames([
              'rounded-full w-4 h-4 flex text-ds-200 border flex-shrink-0 p-px',
              horizontal ? 'm-ds-1.25' : 'mr-3 mt-1.5',
              value === radio.value
                ? 'border-ds-primary focus-visible:border-ds-primary hover:border-ds-primary-400 active:border-ds-primary-500'
                : 'border-ds-natural-200',
              radio.disabled && 'pointer-events-none bg-ds-natural-100',
            ])}
            value={radio.value}
            id={String(radio.id)}
          >
            <RadioGroupPrimitive.Indicator className="flex items-center content-center w-full h-full rounded-full transition-all bg-ds-primary-300 hover:bg-ds-primary-400 active:bg-ds-primary-500" />
          </RadioGroupPrimitive.Item>
          <div className="flex flex-col flex-wrap overflow-auto">
            <div>
              {typeof radio.label === 'string' ? (
                <TextBase
                  label={radio.label}
                  color={
                    radio.disabled
                      ? 'text-ds-natural-200'
                      : 'text-ds-natural-600'
                  }
                />
              ) : (
                radio.label
              )}
            </div>
            {radio.component}
          </div>
        </div>
      ))}
    </RadioGroupPrimitive.Root>
  );
};
